import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input, Menu, Dropdown, Row, Col } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import ProfileModal from '../../components/modals/ProfileModal';
import ChangePasswordModal from '../../components/modals/ChangePasswordModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;
const SubMenu = Menu.SubMenu;

class Profiles extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {names: '', email: '', global: false, rol_id: 1, branch_id: 1, job_id: 1, department_id: 1, clave: '', username: '', password: ''};
    this.state = {redirect: false, profiles: [], filteredProfiles: [], modalVisible: false, modalPasswordVisible: false, current: this.schema, handleSave: this.handleCreate, departments: [], branches: [], jobs: [], rols: []};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getProfiles = this.getProfiles.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenPasswordModal = this.handleOpenPasswordModal.bind(this);
    this.handleClosePasswordModal = this.handleClosePasswordModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleSavePassword = this.handleSavePassword.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getProfiles();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getProfiles() {
    axios.get(`${Configuration.apiServer}/api/v1/profiles`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({profiles: resp.data, filteredProfiles: resp.data});
    });
  }

  getDepartments() {
    axios.get(`${Configuration.apiServer}/api/v1/departments`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({departments: resp.data});
    });
  } 

  getBranches() {
    axios.get(`${Configuration.apiServer}/api/v1/branches`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({branches: resp.data});
    });
  }

  getJobs() {
    axios.get(`${Configuration.apiServer}/api/v1/jobs`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({jobs: resp.data});
    });
  }

  getRols() {
    axios.get(`${Configuration.apiServer}/api/v1/rols`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({rols: resp.data});
    });
  }

  handleStatus(url, id) {
    axios.put(`${Configuration.apiServer}/api/v1/profiles/${id}/${url}`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado');
      this.getProfiles();
    });
  }

  handleSearch(event) {
    const profiles = this.state.profiles.filter(profile => {
      return profile.names.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredProfiles: profiles});
  }

  handleOpenModal(kind, record) {
    this.getDepartments();
    this.getBranches();
    this.getJobs();
    this.getRols();

    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleOpenPasswordModal(record) {
    this.setState({modalPasswordVisible: true, current: record});
  }

  handleClosePasswordModal() {
    this.setState({modalPasswordVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/profiles`, {profile: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getProfiles();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/profiles/${this.state.current.id}`, {profile: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getProfiles();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }

  handleSavePassword(password) {
    axios.put(`${Configuration.apiServer}/api/v1/profiles/${this.state.current.id}/password`, {user: {password}}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getProfiles();
      this.setState({modalPasswordVisible: false});
      message.success('Registro actualizado');
    });
  }

  statusText(status) {
    if(status) {
      return 'Desctivar';
    } else {
      return 'Activar';
    }
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of profiles
    const profiles = this.state.filteredProfiles.map(profile => {
      const statusMenu = (
        <Menu>
          <Menu.Item><span onClick={() => { this.handleOpenPasswordModal(profile) }}>Re-asignar contraseña</span></Menu.Item>
          <Menu.Item><a href={`/admin/users/${profile.id}/cars`}>Autos registrados</a></Menu.Item>
          <SubMenu title="Notificaciones para transportistas">
            <Menu.Item><span onClick={() => { this.handleStatus('carriers_notification', profile.id) }}>{this.statusText(profile.carriers_notification)}</span></Menu.Item>
          </SubMenu>
          <SubMenu title="Ver visitas de transportistas">
            <Menu.Item><span onClick={() => { this.handleStatus('view_carriers', profile.id) }}>{this.statusText(profile.view_carriers)}</span></Menu.Item>
          </SubMenu>
          <SubMenu title="Accesos web">
            <Menu.Item><span onClick={() => { this.handleStatus('web_login', profile.id) }}>{this.statusText(profile.web_login)}</span></Menu.Item>
          </SubMenu>
          <SubMenu title="Accesos móvil">
            <Menu.Item><span onClick={() => { this.handleStatus('mobile_login', profile.id) }}>{this.statusText(profile.mobile_login)}</span></Menu.Item>
          </SubMenu>
          <SubMenu title="Usuario global">
            <Menu.Item><span onClick={() => { this.handleStatus('global', profile.id) }}>{this.statusText(profile.global)}</span></Menu.Item>
          </SubMenu>
        </Menu>
      );

      return (
        <Col md={6} style={{marginTop: "25px"}} key={`user-${profile.id}`}>
          <Card
            className=""
            actions={[
              <a href={`/admin/users/${profile.id}`}><Icon type="eye" /></a>, 
              <Icon type="edit" onClick={() => { this.handleOpenModal('edit', profile) }} />,
              <Dropdown overlay={statusMenu}>
                <span className="ant-dropdown-link">
                  <Icon type="ellipsis" />
                </span>
              </Dropdown>
            ]}
            key={profile.id}
          >
            <Meta
              avatar={<Avatar icon="user" />}
              description={profile.user && profile.user.deleted ? 
                <span class="text-danger">Eliminado</span>
              :
                <span className={`cursor text-${Configuration.getStatus(profile.status).color}`} onClick={() => { this.handleStatus('status', profile.id) }}>{Configuration.getStatus(profile.status).text}</span>
              }
            />
            <p className="text-muted text-capitalize" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '0px' }}>
              Rol: {profile.rol.name.toLowerCase()}
            </p>
            <h5 style={{height: 73, marginTop: 10, marginBottom: 0}}>{profile.names}</h5>
            <hr />
            <p className="text-muted text-capitalize text-center" style={{ marginBottom: 0,  marginTop: 0 }}>
              <Icon type="idcard" /> {('job' in profile) ? profile.job.name.toLowerCase().substring(0, 22) : 'Sin puesto'}
            </p>
            <p className="text-muted text-center" style={{ marginBottom: 0,  marginTop: 5 }}>
              <Icon type="idcard" /> {('user' in profile) ? profile.user.username : 'Sin usuario'}
            </p>
          </Card>
        </Col>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Usuarios</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <Row gutter={16}>
            {profiles}
          </Row>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />

        <ProfileModal visible={this.state.modalVisible} title={"Nuevo usuario"} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} departments={this.state.departments} branches={this.state.branches} jobs={this.state.jobs} rols={this.state.rols} />
        <ChangePasswordModal visible={this.state.modalPasswordVisible} title={"Re-asignar contraseña"} handleClose={this.handleClosePasswordModal} handleSave={this.handleSavePassword} />
      </div>
    );
  }
}

export default Profiles;



// WEBPACK FOOTER //
// ./src/pages/admin/Profiles.js